<div [formGroup]="usernameGroup" class="form-group-control">
  <div class="userCredentials">
    <span class="pull-right forgotElement">
      <a
        [attr.id]="forgotUsernameLink.id"
        [routerLink]="forgotUsernameLink.url"
        [attr.aria-label]="forgotUsernameLink.text"
        tabindex="7"
        (click)="trackCtaActions(GTMTracking.LoginClickForgottenUsername)"
        >{{ forgotUsernameLink.text }}</a
      >
    </span>
    <label for="j_username" class="userCredentials">
      Username
      <span
        (click)="trackCtaActions(GTMTracking.LoginViewUsernameToolTip)"
        *ngIf="displayUserNameTooltip"
        data-component="tooltip"
        [text]="
          'Use your existing username and passcode unless you have received an email saying otherwise'
        "
      ></span>
    </label>
    <div class="password-wrapper userNameComponent">
      <input
        id="j_username"
        name="j_username"
        [attr.type]="usernameInputHidden ? 'password' : 'text'"
        [ngClass]="{ error: fieldHasError() }"
        [attr.aria-describedby]="fieldHasError() ? 'usernameError' : null"
        [attr.aria-invalid]="fieldHasError()"
        formControlName="userName"
        placeholder="Username"
        autocomplete="off"
        aria-required="true"
        value=""
        maxlength="254"
        required
        data-test-id="input-username"
        tabindex="2"
      />
    </div>
    <div id="usernameError" aria-live="polite" role="alert">
      <span
        *ngIf="fieldHasRequiredError()"
        class="error-msg"
        data-test-id="text-inline-required-username"
      >
        Username is required
      </span>
    </div>
  </div>
  <div *ngIf="(cookiePreferences | async)?.userPreferences">
    <div class="form-group-control">
      <div class="checkbox-wrapper">
        <input
          id="rememberMe"
          name="rememberMe"
          type="checkbox"
          formControlName="rememberMe"
          data-test-id="input-rememberme"
          aria-describedby="btnIsPublicDevice"
          tabindex="5"
          (change)="trackCtaActions(GTMTracking.LoginCheckRememberMyUsername)"
        />
        <label class="mock-label" for="rememberMe">
          Remember my username
        </label>
      </div>
    </div>
    <p id="btnIsPublicDevice" class="text-primary">
      Don't tick this box if you're using a public or shared device
    </p>
  </div>
</div>
